import { post } from "@src/appV2/api/api";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import {
  useMutation,
  type UseMutationOptions,
  type UseMutationResult,
} from "@tanstack/react-query";
import { z } from "zod";

import { FRIENDS_ENDPOINT } from "../constants";

export const SendFriendRequestResponseSchema = z.object({
  data: z.object({
    type: z.literal("worker-friend-request"),
    attributes: z.object({
      status: z.enum(["REQUESTED", "ACCEPTED"]),
    }),
  }),
});

export type SendFriendRequestResponse = z.infer<typeof SendFriendRequestResponseSchema>;

export function useSendFriendRequest(
  options?: Omit<UseMutationOptions<SendFriendRequestResponse, unknown, string>, "mutationFn">
): UseMutationResult<SendFriendRequestResponse, unknown, string> {
  const worker = useDefinedWorker();
  return useMutation({
    mutationFn: async (workerId: string) => {
      const result = await post({
        url: `${FRIENDS_ENDPOINT(worker.userId)}/friend-requests`,
        responseSchema: SendFriendRequestResponseSchema,
        data: {
          data: {
            type: "worker-friend-request",
            relationships: {
              targetWorker: {
                data: {
                  type: "worker",
                  id: workerId,
                },
              },
            },
          },
        },
      });
      return result.data;
    },
    ...options,
  });
}
